export interface RuntimeConfig {
  apiUrl: string;
}

let _config: RuntimeConfig | null = null;

export async function loadConfig(): Promise<void> {
  const res = await fetch('/runtimeConfiguration.json');
  if (!res.ok) throw new Error(`Failed to load runtime config: ${res.status}`);
  _config = (await res.json()) as RuntimeConfig;
}

export function getConfig(): RuntimeConfig {
  if (!_config) throw new Error('Runtime config not loaded');
  return _config;
}
